import * as React from 'react';

import { cn } from 'lib/utils';
import {
  Panel,
  PanelGroup,
  PanelGroupProps,
  PanelProps,
  PanelResizeHandle,
  PanelResizeHandleProps,
} from 'react-resizable-panels';

const ResizablePanelGroup = React.forwardRef<
  React.ElementRef<typeof PanelGroup>,
  PanelGroupProps
>(({ className, ...props }, ref) => (
  <PanelGroup ref={ref} className={cn('flex w-full', className)} {...props} />
));
ResizablePanelGroup.displayName = 'ResizablePanelGroup';

const ResizablePanel = React.forwardRef<
  React.ElementRef<typeof Panel>,
  PanelProps
>(({ className, ...props }, ref) => (
  <Panel ref={ref} className={cn('flex flex-col', className)} {...props} />
));
ResizablePanel.displayName = 'ResizablePanel';

type ResizableHandleProps = PanelResizeHandleProps & {
  withHandle?: boolean;
};

const ResizableHandle = ({
  className,
  withHandle = false,
  ...props
}: ResizableHandleProps) => (
  <PanelResizeHandle
    className={cn(
      'relative flex w-px items-center justify-center bg-border transition hover:bg-border',
      className
    )}
    {...props}
  >
    {withHandle ? (
      <div className="z-10 flex h-10 w-2 items-center justify-center rounded-full border border-border bg-background">
        <div className="h-4 w-[2px] rounded-full bg-border" />
      </div>
    ) : null}
  </PanelResizeHandle>
);
ResizableHandle.displayName = 'ResizableHandle';

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
